import React, { useState } from 'react';
import BlogCard from './BlogCard';
import '../css/BlogGrid.css';
import blogData from './blogData';

const BlogGrid = () => {
    const [activeFilter, setActiveFilter] = useState('all');

    const filters = [
        { id: 'all', label: 'All Posts' },
        { id: 'tax-loss-harvesting', label: 'Tax Loss Harvesting' },
        { id: 'wash-sales', label: 'Wash Sales' },
        { id: 'cost-basis', label: 'Cost Basis' },
        { id: 'capital-gains', label: 'Capital Gains' },
        { id: 'retirement', label: 'Retirement' },
        { id: 'etfs', label: 'ETFs' },
        { id: 'tax-planning', label: 'Tax Planning' }
    ];

    const filteredBlogs = activeFilter === 'all' 
        ? blogData 
        : blogData.filter(blog => {
            // Check if any of the blog's tags include the active filter
            const searchTerm = activeFilter.replace(/-/g, ' ');
            return blog.tags.some(tag => 
                tag.toLowerCase().includes(searchTerm.toLowerCase())
            );
        });

    return (
        <div className="blog-grid">
            <div className="blog-grid-header">
                <h1 className="blog-grid-title">Latest Tax Insights</h1>
                <p className="blog-grid-description">
                    Discover strategies to optimize your investments and minimize your tax burden with our expert insights.
                </p>
            </div>

            <div className="blog-filters-container">
                <div className="blog-filters">
                    {filters.map(filter => (
                        <button
                            key={filter.id}
                            className={`blog-filter-button ${activeFilter === filter.id ? 'active' : ''}`}
                            onClick={() => setActiveFilter(filter.id)}
                        >
                            {filter.label}
                        </button>
                    ))}
                </div>
            </div>

            <div className="blog-posts-grid">
                {filteredBlogs.map((blog) => (
                <BlogCard
                        key={blog.id}
                        {...blog}
                />
            ))}
            </div>
        </div>
    );
};

export default BlogGrid;
